import { Header, Product } from "../../Components";

import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import "./products.css";
const Products = () => {
  const { t } = useTranslation();
  const allProducts = t("allProducts", { returnObjects: true });
  return (
    <Fragment>
      <Header
        bgTitle={document.body.dir === "ltr" ? "Products" : "منتجاتنا"}
      ></Header>
      <section className="container">
        {allProducts.map((item) => {
          return <Product key={item.id} product={item}></Product>;
        })}
      </section>
    </Fragment>
  );
};
export default Products;
